import { actionGenerator } from '../../utils/redux/actionGenerator';
import { INotificationState } from '../../types/redux/notificator';

export enum EActionTypes {
  SetNotification = 'notification/set_notification',
  ClearNotification = 'notification/clear_notification',
}

export const updateNotification = actionGenerator<EActionTypes.SetNotification, Partial<INotificationState>>(
  EActionTypes.SetNotification,
);

export const clearNotification = actionGenerator<EActionTypes.ClearNotification>(EActionTypes.ClearNotification);

export type TNotificationActions = ReturnType<typeof updateNotification> | ReturnType<typeof clearNotification>;
